export enum JackpotBetPrizeType {
    Small = 0,
    Medium = 1,
    Big = 2,
    Large = 4,
    Mega = 5,
    Ultra = 6,
}


export interface IJackpotBetsInfoViewModel {
    readonly winnersCount: number;
    readonly totalWinsToday: number;
    readonly animatedTotalWinsToday: number;
    getPrizes(): IJackpotBetPrizeViewModel[];
}

export interface IJackpotBetPrizeViewModel {
    readonly type: JackpotBetPrizeType;
    readonly jackpotId: number;
    readonly amount: number;
    readonly label: string;
}